
import { computed, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import { _MODAL_TYPE } from '@/enums';
import { $api } from '@/services';
import { useStore } from 'vuex';
import DownloadCSV from '@/mixins/downloadCSV.vue';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import Loading from '@/components/common/Loading.vue';
import GoalList from '@/components/elements/GoalList.vue';
import { ACTIONS } from '@/enums/Common';
import ConfirmSendReportTarget from '@/views/groupClassPlansDetail/features/reportTarget/confirmSendReportTarget/ConfirmSendReportTarget.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import GroupDetail from '@/components/modules/groups/GroupDetail.vue';

export default defineComponent({
	name: 'GroupClassPlansDetailReport',
	components: {
		GroupDetail,
		DaModalFrame,
		ConfirmSendReportTarget,
		GoalList,
		Loading,
		Menu,
		MenuItem,
		MenuItems,
		MenuButton,
	},
	setup() {
		const route = useRoute();
		const store = useStore();
		const report = ref(null as any);
		const stats = ref(null as any);

		const isLoading = ref(true);
		const modalIsOpen = ref(false);
		const modalType = ref('');

		const id = computed(() =>
			route.params?.id ? route.params?.id + '' : ''
		);

		function cancel() {
			modalIsOpen.value = false;
			modalType.value = '';
		}

		const type = computed(() => ACTIONS);
		const reportName = ref('');

		function confirmSendOpen() {
			modalIsOpen.value = true;
			reportName.value = report.value?.order || '';
			modalType.value = type.value.CREATE;
		}

		async function sendNotification() {
			try {
				await $api.groupClasses.sendReport(id.value, report.value?.id);
				cancel();
				await listGroup();
				await store.dispatch('setAlertMessage', {
					message: 'Gửi kế hoạch đến phụ huynh thành công',
				});
			} catch (err) {
				await store.dispatch('setAlertMessage', {
					message:
						err?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		}

		const groups = ref([] as any);

		async function listGroup() {
			try {
				const {
					data: { group_plan, data, stats: s },
				} = await $api.groupClasses.getListGroupWithDetail(id.value);
				report.value = group_plan;
				groups.value = data;
				stats.value = s;
			} catch (err) {
				await store.dispatch('setAlertMessage', {
					message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				isLoading.value = false;
			}
		}

		listGroup();

		return {
			id,
			modalIsOpen,
			modalType,
			report,
			stats,
			groups,
			modalTypes: computed(() => _MODAL_TYPE),
			org: computed(() => store.state.profile.current_org),
			isLoading,
			type,
			reportName,
			cancel,
			confirmSendOpen,
			sendNotification,
			listGroup,
		};
	},
	mixins: [DownloadCSV],
});
